import React, { useCallback, useState } from 'react';
import { ICustomError, ICardsMap } from 'types';

import { PopupChangeClassicBacResultComponent } from './PopupChangeClassicBacResult';

interface IProps {
  onClose: () => void;
  onSubmitManualInput: (cards: ICardsMap) => void;
  manualInputLoading: boolean;
  manualInputError?: ICustomError;
  onCancelLastCard: () => void;
  cancelLastCardDisabled?: boolean;
  onReScanAllCards: () => void;
  changeResultError?: ICustomError;
}

export const PopupChangeClassicBacResult = ({
  onClose,
  manualInputError,
  manualInputLoading,
  onSubmitManualInput,
  onCancelLastCard,
  cancelLastCardDisabled,
  onReScanAllCards,
  changeResultError,
}: IProps) => {
  const [isManualInputSelected, setIsManualInputSelected] = useState<boolean>(false);
  const onManualInput = useCallback(() => setIsManualInputSelected(true), []);
  const onCloseManualInput = useCallback(() => setIsManualInputSelected(false), []);

  return (
    <PopupChangeClassicBacResultComponent
      onClose={onClose}
      manualInputLoading={manualInputLoading}
      manualInputError={manualInputError}
      isManualInputSelected={isManualInputSelected}
      onManualInput={onManualInput}
      onSubmitManualInput={onSubmitManualInput}
      onCloseManualInput={onCloseManualInput}
      onCancelLastCard={onCancelLastCard}
      cancelLastCardDisabled={cancelLastCardDisabled}
      onRescanAllCards={onReScanAllCards}
      changeResultError={changeResultError}
    />
  );
};
